module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter02"
    }
  }, [_vm._v("Introduction: Feminism, Front and Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Linda Beail and Lilly J. Goren")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('strong', [_vm._v("Part I: Feminism and the Idea and Constraints of Freedom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01chapter01#part01chapter01"
    }
  }, [_vm._v("1. "), _c('em', [_vm._v("Extreme Makeover")]), _vm._v(" and the Classical Logic of Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Emily Askew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter02#part01chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Smart, Funny, and Romantic? Femininity and Feminist Gestures in Chick Flicks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Laurie Naranch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter03#part01chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. From Madonna to Lilith and Back Again: Women, Feminists, and Pop Music in the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Rachel Henry Currans-Sheehan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part II: Housewives and Presidents: Cultural Understandings of Television Dramas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter04#part02chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Reformer and Her Work: Transgression, Alienation, and Feminine Identity in the Police Procedural")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Peter Josephson and Rebecca Colton Josephson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter05#part02chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The City, the Suburbs, and Stars Hollow: The Return of the Evening Soap Opera")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Linda Beail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter06#part02chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Why Are All the Presidents Men? Televisual Presidents and Patriarchy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Linda Horwitz and Holly Swyers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part III: The Mommy Brigade")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter07#part03chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Baby Lit: Feminist Response to the Cult of True Motherhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Melissa Buis Michaux and Leslie Dunlap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter08#part03chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Supermom: The Age of the Pregnant Assassin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Lilly J. Goren")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter09#part03chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Mommy Track versus Having It All: The Reality of the Modern Workplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Julia Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part IV: What Do Women Want?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter10#part04chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. It Was Chick Lit All Along: The Gendering of a Genre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Cecilia Konchar Farr")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter11#part04chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Personal Is Political: Women’s Magazines for the “I’m-Not-a-Feminist-But” Generation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Natalie Fuehrer Taylor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter12#part04chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Money, Honey: The Rise of the Female Anchor, the Female Reporter, and Women in the News Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('em', [_vm._v("Mary McHugh")])]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0